import { useState } from 'react';
import { applyUpdate, dismissUpdate, useAppUpdate } from '../lib/app-update';
import { useTracking } from '../services/runtime';
import { useT } from '../i18n';
import { Button } from './ui';

/** "A new version is ready": the runner reloads when it suits them — never offered during a run. */
export function UpdateBanner() {
  const { available, dismissed } = useAppUpdate();
  const state = useTracking((s) => s.state);
  const [busy, setBusy] = useState(false);
  const t = useT();
  const running = state === 'RUNNING' || state === 'PAUSED' || state === 'RESUMING' || state === 'FINISHING';
  if (!available || dismissed || running) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-50 px-3 pt-[calc(var(--safe-top)+8px)]" role="status" data-testid="update-banner">
      <div className="mx-auto flex max-w-lg gap-3 rounded-2xl border border-volt/40 bg-ink-850/95 p-4 shadow-xl backdrop-blur">
        <span className="grid size-9 shrink-0 place-items-center rounded-full bg-volt/15 text-lg">✨</span>
        <div className="min-w-0 flex-1">
          <div className="font-semibold">{t('A new version is available')}</div>
          <p className="text-sm text-ink-300">{t('Reload to get the latest version. Your progress is kept.')}</p>
          <div className="mt-3 flex gap-2">
            <Button
              size="sm"
              loading={busy}
              onClick={() => {
                setBusy(true);
                void applyUpdate();
              }}
              data-testid="update-now"
            >
              {t('Update')}
            </Button>
            <Button size="sm" variant="ghost" onClick={dismissUpdate} data-testid="update-later">
              {t('Later')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
